import useChargeDiscountBreakdown from '@/hooks/usePriceBreakdown.js';
import { useTranslations } from 'next-intl';
import React, { useContext, useState } from 'react';
import { PriceBreakdown } from '@desquared/wave-components-library';
import { CurrencyContext } from '@/contexts/CurrencyProvider';

export default function PriceBreakDownDetails({ selectedOrder }) {
  const t = useTranslations();

  const [bags, setBags] = useState(false);
  const [breakdownCategories, setBreakdownCategories] = useState([]);
  const [couponDiscount, setCouponDiscount] = useState({ isValid: false, message: '', amount: 0 });
  const [discountstate, setDiscountState] = useState(false);
  const [hasCoupon, setHasCoupon] = useState(false);
  const [coupon, setCoupon] = useState('');
  const [priceCart, setCartPrice] = useState();
  const [paymentOptions, setPaymentOptions] = useState([]);
  const { formatter } = useContext(CurrencyContext);

  useChargeDiscountBreakdown(
    selectedOrder,
    selectedOrder?.fees?.some(el => el.type === 'PLASTIC_BAGS'),
    discountstate,
    hasCoupon,
    coupon,
    priceCart,
    setCartPrice,
    setBreakdownCategories,
    setPaymentOptions,
    undefined,
    undefined,
    couponDiscount
  );

  return (
    <PriceBreakdown
      headerTitle={t(`full_page_cart.price_breakdown_title`)}
      categories={breakdownCategories}
      hasProgressBar={false}
      finalSumDescription={t('full_page_cart.final_sum_title')}
      finalSumValue={formatter.format(selectedOrder?.totalPrice / 100)}
      additionalPaymentHold={
        selectedOrder?.additionalPaymentHold?.value
          ? t('common.checkout.paymentHold_first') +
            ' ' +
            selectedOrder?.additionalPaymentHold?.value * 100 +
            t('common.checkout.paymentHold_second')
          : undefined
      }
    />
  );
}
